import { createContext } from 'react'

export const defaultFlagUpdateTree = true // A alterância deste flag ( cujo valor não importa ) disparará a atualização do TreeView
                                  
const FlagUpdateTreeContext = createContext({flagUpdateTree:defaultFlagUpdateTree, setFlagUpdateTree: () => {}}) 

export default FlagUpdateTreeContext